module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/X711zA/tc-custom/9781612437699.jpg?1729185361901",
      "alt": "This image is the cover for the book Beyond Bullets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beyond Bullets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Easy, inspiring suggestions for bullet journaling, a unique organizational tool to make your daily planning more productive and artistic. ")]), _c('br'), _c('br'), _vm._v(" Fun, colorful, and creative suggestions for the newest productivity phenomenon!"), _c('br'), _c('br'), _vm._v(" Going beyond basic tools, "), _c('i', [_vm._v("BEYOND BULLETS")]), _vm._v(" offers tips, tricks and creative ways to transform your notebook into a treasured life companion, including:"), _c('br'), _c('br'), _vm._v(" • Ornamental lettering"), _c('br'), _c('br'), _vm._v(" • Personalized habit trackers"), _c('br'), _c('br'), _vm._v(" • Colorful calendars"), _c('br'), _c('br'), _vm._v(" • Decorative headers"), _c('br'), _c('br'), _vm._v(" • Customized productivity lists"), _c('br'), _c('br'), _vm._v(" • Inspiring artwork"), _c('br'), _c('br'), _vm._v(" • Creative future logs"), _c('br'), _c('br'), _vm._v(" • Unique planning pages"), _c('br'), _c('br'), _c('i', [_vm._v("BEYOND BULLETS")]), _vm._v(" is the perfect guide to motivate beginners to start a daily journal routine, or for intermediate to advanced journalers to take their practice to the next level! \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Megan Rutell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0